const initialState = {
  isLogin: false,
};
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "getuserdata":
      state = { ...state, ...action.payload };
      return state
    case "toggleAISwitch":
      state = { ...state, searchToggle: action.payload };
      return state;
    case "isUserLoggedInOrNot":
      state = { ...state, isLogin: action.payload };
      return state;
    case "groupInfoBriefCountChanged":
      state = { ...state, briefThreshold: action.payload }
      return state;
    case "usedBriefCountChanged":
      state = { ...state, usedBriefCount: action.payload }
      return state;
    default:
      return state;
  }
};

export default userReducer;
